import { Field } from 'components/Wizards/Field/Field'
import { RepresentationAge } from './RepresentationAge'
import { RepresentationGender } from './RepresentationGender'
import { RepresentationCulture } from './RepresentationCulture'
import { RepresentationDetails } from './RepresentationDetails'
import cx from 'classnames'
import Styles from './RepresentationPreferences.module.scss'
import { OptionalFieldProps } from '../types'
import { HeadingLevel } from 'almanac-ui/Heading/Heading'

type Props = {
  ageRange?: string
  gender?: string
  culture?: string
  details?: string
  onAgeRangeUpdate: (ageRange: string) => void
  onGenderUpdate: (gender: string) => void
  onCultureUpdate: (culture: string) => void
  onDetailsUpdate: (details: string) => void
  hideDetails?: boolean
  headingLevel?: HeadingLevel
  labelColor?: string
  inlineAgeAndGender?: boolean
  className?: string
} & OptionalFieldProps

const RepresentationPreferences = ({
  ageRange,
  gender,
  culture,
  details,
  onAgeRangeUpdate,
  onGenderUpdate,
  onCultureUpdate,
  onDetailsUpdate,
  hideDetails = false,
  fieldProps,
  headingLevel = 3,
  labelColor,
  inlineAgeAndGender = false,
  className,
}: Props) => {
  return (
    <Field
      label="Who appears in content"
      headingLevel={headingLevel}
      data-testid="representation-preferences"
      labelColor={labelColor}
      {...fieldProps}
    >
      <div className={Styles.fieldGroup}>
        <div className={cx(Styles.fields, className)}>
          {inlineAgeAndGender ? (
            <div className={Styles.inlineAgeAndGenderFields}>
              <div className={Styles.field}>
                <RepresentationAge ageRange={ageRange} onUpdate={onAgeRangeUpdate} labelColor={labelColor} />
              </div>
              <div className={Styles.field}>
                <RepresentationGender gender={gender} onUpdate={onGenderUpdate} labelColor={labelColor} />
              </div>
            </div>
          ) : (
            <>
              <div className={Styles.field}>
                <RepresentationAge ageRange={ageRange} onUpdate={onAgeRangeUpdate} labelColor={labelColor} />
              </div>
              <div className={Styles.field}>
                <RepresentationGender gender={gender} onUpdate={onGenderUpdate} labelColor={labelColor} />
              </div>
            </>
          )}
          <div className={Styles.field}>
            <RepresentationCulture culture={culture} onUpdate={onCultureUpdate} labelColor={labelColor} />
          </div>
        </div>
        {!hideDetails && (
          <div className={cx(Styles.fields, Styles.detailsField)}>
            <RepresentationDetails details={details} onUpdate={onDetailsUpdate} labelColor={labelColor} />
          </div>
        )}
      </div>
    </Field>
  )
}

export { RepresentationPreferences }
